module.exports = __webpack_public_path__ + "img/Skirt-Front-B1-Db-Fb-Ga-Hc-Ia.85922667.png";